"use strict";
/**
 * Created by Jonas Wålekvist on 2019-11-15.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIBetType = void 0;
var APIBetType;
(function (APIBetType) {
    APIBetType["NORMAL_BET"] = "normalBet";
    APIBetType["FREE_BET"] = "freeBet";
    APIBetType["ZERO_BET"] = "zeroBet";
    APIBetType["GAMBLE_BET"] = "gambleBet";
    APIBetType["PICK_AND_CLICK_BET"] = "pickAndClickBet";
    APIBetType["FEATURE_BET"] = "featureBet";
})(APIBetType = exports.APIBetType || (exports.APIBetType = {}));
//# sourceMappingURL=APIBetType.js.map